import { useQuery } from '@tanstack/vue-query'
import type { SuccessResponse } from '~/types/response'

export type Package = {
  id: string
  name: string
  tier: string | null
  billingPeriod: string | null
  price: number
  description: string | null
  features: string[]
  featureDescriptions?: Record<string, string>
  accessLevel?: string
  badgeNumber?: number | null
  badgeColor?: string | null
  stripeProductId: string | null
  paypalPlanId: string | null
  isActive: boolean
  userCount: number
  createdAt: Date
  updatedAt: Date
}

export const usePackages = () => {
  return useQuery({
    queryKey: ['packages'],
    queryFn: () =>
      $fetch<SuccessResponse<Package[]>>('/api/packages').then((data) => {
        if (typeof data === 'string') {
          return JSON.parse(data)
        }
        return data
      }),
    retry: false,
    refetchOnWindowFocus: false,
  })
}

